export enum AlertDialogType {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}
